import styled from 'styled-components';

import { VerticalCenterBlock } from '../../../../styled';

export const DateWrapper = styled.div`
  ${(p) => p.theme.typography.label};
  color: ${(p) => p.theme.colors.disabled};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  flex-shrink: 2;
`;

export const ButtonsWrapper = styled(VerticalCenterBlock)`
  gap: 10px;
`;
